<template>
  <div class="home">
    <cw-banner v-if="isbanner" class="banner" />
    <div class="bg-1" :style="{ 'background-image': 'url(' + bg1 + ')' }">
      <div class="bg-1-container">
        <cw-introduce />
        <cw-service />
      </div>
    </div>
    <div class="container">
      <cw-cooperation v-if="isCooperation" />
      <cw-exhibition />
      <cw-news />
    </div>
  </div>
</template>

<script>
import banner from '../../components/Banner/banner'
import introduce from '../../components/Introduce/introduce'
import service from '../../components/Service/service'
import cooperation from '../../components/Cooperation/cooperation'
import exhibition from '../../components/Exhibition/exhibition'
import news from '../../components/News/news'

export default {
  name: 'Home',
  components: {
    cwBanner: banner,
    cwIntroduce: introduce,
    cwService: service,
    cwCooperation: cooperation,
    cwExhibition: exhibition,
    cwNews: news
  },
  data() {
    return {
      isButton: true,
      isbanner: true,
      isCooperation: false,
      bg1: require('@/assets/images/background/bg-1.jpg')
    }
  },
  mounted() {
    // this.axios.get('http://47.107.74.239:3825/page/view?type=1').then()
  }
}
</script>

<style scoped>
.container {
  width: 1180px;
  margin: auto;
}

.bg-1-container {
  width: 1180px;
  margin: auto;
  color: #ffffff;
}

.bg-1 {
  padding: 20px 20px 10px 20px;
}
</style>
